export default __webpack_public_path__ + "static/media/Picture1.2ccf5de4.png";